import React, { FC, useState } from 'react';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Menu from 'vibo-ui/Menu';
import ClickAwayListener from 'vibo-ui/ClickAwayListener';

import { useMe } from 'graphql/hooks/user';
import { getSelectedResourcesMenuKeys } from 'services/common/routesHelper';
import { MEET_UPS_LINK, VIBO_BRANDING_LINK, VIBO_MERCH_LINK } from 'services/constants';

import { IconmoonFont } from 'vibo-ui/Icon';

import useStyles from './style';

const ResourcesMenu: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);

  const navigate = useNavigate();

  const { isDj, isAdmin } = useMe();

  const toggleOpenMenu = () => setIsOpen(!isOpen);

  const handleOpenMeetUps = () => window.open(MEET_UPS_LINK, '_blank', 'noreferrer');

  const handleOpenBranding = () => window.open(VIBO_BRANDING_LINK, '_blank', 'noreferrer');

  const handleOpenMerch = () => window.open(VIBO_MERCH_LINK, '_blank', 'noreferrer');

  return (
    <ClickAwayListener onClickAway={() => setIsOpen(false)}>
      <Menu.Item
        onMouseDown={toggleOpenMenu}
        icon={IconmoonFont['resources-24']}
        title={t('resources')}
        key="/resources"
      >
        <span>{t('resources')}</span>
      </Menu.Item>
      <Menu
        className={classNames('siderSubMenu', classes.siderSubMenu, {
          isOpen,
        })}
        getSelectedSidebarMenuKeys={getSelectedResourcesMenuKeys}
        styleModificator="siderLeft"
        selectedKeys={[]}
      >
        {isDj ? (
          <Menu.Item
            onClick={() => navigate('/academy')}
            icon={IconmoonFont['academy-16']}
            title={t('academy')}
            key="/academy"
          >
            <span>{t('academy')}</span>
          </Menu.Item>
        ) : null}
        {isDj || isAdmin ? (
          <Menu.Item
            onClick={() => navigate('/marketing-assets')}
            icon={IconmoonFont['crown-16']}
            title={t('marketing')}
            key="/marketing-assets"
          >
            <span>{t('marketing')}</span>
          </Menu.Item>
        ) : null}
        <Menu.Item
          onClick={handleOpenMeetUps}
          icon={IconmoonFont['meet-ups-16']}
          title="MeetUps"
          key="/meetups"
        >
          <span>MeetUps</span>
        </Menu.Item>
        <Menu.Item
          onClick={handleOpenBranding}
          icon={IconmoonFont['palette-16']}
          title={t('branding')}
          key="/branding"
        >
          <span>{t('branding')}</span>
        </Menu.Item>
        <Menu.Item
          onClick={handleOpenMerch}
          icon={IconmoonFont['t-short-16']}
          title="Merch"
          key="/merch"
        >
          <span>Merch</span>
        </Menu.Item>
      </Menu>
    </ClickAwayListener>
  );
};

export default ResourcesMenu;
